
export default {
  data() {
    return {tabs: [] };
  },
  watch: {
    tabs() {
      if (this.tabs.length) {
        this.selectTab(this.tabs[0])
      }
    }
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name);
      });
    }
  }
}
